import { ReactNode, useEffect, useState } from 'react';

import { Icon } from '@amazd/common/assets/icons';
import CompanyIcon from '@amazd/common/icons/CompanyIcon';
import WidgetConfiguratorIcon from '@amazd/common/icons/WidgetConfiguratorIcon';
import { useTranslation } from '@amazd/common/utils/i18n';
import { Drawer, Grid, List, ListItem, ListItemText, Typography, useMediaQuery, useTheme } from '@mui/material';
import DashboardLayout from 'layouts/DashboardLayout';

import SidebarLink from './SidebarLink';
import useStyles from './styles';

interface CompanySettingsLayoutProps {
  containerClassName?: string;
  children: ReactNode;
}

const CompanySettingsLayout = ({ containerClassName, children }: CompanySettingsLayoutProps) => {
  const classes = useStyles();
  const theme = useTheme();
  const desktopMode = useMediaQuery(theme.breakpoints.up('lg'));
  const { t } = useTranslation();

  const [drawerState, setDrawerState] = useState(false);

  useEffect(() => {
    desktopMode ? showDrawer() : hideDrawer();
  }, [desktopMode]);

  const hideDrawer = () => {
    setDrawerState(false);
  };

  const showDrawer = () => {
    setDrawerState(true);
  };

  const toggleDrawer = () => {
    setDrawerState(!drawerState);
  };

  return (
    <DashboardLayout
      disableMaxWidth={true}
      className={classes.root}
      title={'Company Settings'}
      showDrawerButton={!desktopMode}
      onDrawerButtonClick={toggleDrawer}
    >
      <Drawer className={classes.drawer} anchor="left" variant="persistent" open={desktopMode || drawerState}>
        <div className={classes.sidebar}>
          <List className={classes.list}>
            <ListItem>
              <ListItemText
                primary={
                  <Typography color="textSecondary" className={classes.sidebarTitle}>
                    {t('company-settings-title')}
                  </Typography>
                }
              />
            </ListItem>
            <SidebarLink
              link="/company-settings/company-profile"
              icon={<CompanyIcon />}
              text={t('company-settings-menu-company-profile')}
            />
            <SidebarLink
              link="/company-settings/widget-configurator"
              icon={<WidgetConfiguratorIcon />}
              text={t('company-settings-menu-widget-configurator')}
            />
            <SidebarLink
              link="/company-settings/shop-integration"
              icon={<Icon name="shop-integration" />}
              text={t('company-settings-menu-shop-integration')}
            />
          </List>
        </div>
      </Drawer>
      <Grid className={`${classes.container} ${containerClassName}`} onClick={hideDrawer}>
        {children}
      </Grid>
    </DashboardLayout>
  );
};

export default CompanySettingsLayout;
